import '@/app/app.css';
import './about.css';

import '@/app/app';

document.addEventListener('DOMContentLoaded', () => {
	const aboutVideo = document.querySelector('.about-video .js-video');
	if (aboutVideo) {
		aboutVideo.classList.add('js-video--observer');
		aboutVideo.querySelector('video').muted = true;
		aboutVideo.querySelector('video').loop = true;
		app.classInstance.get(aboutVideo)?.video.play();
	}
});
